import styled from 'styled-components';

interface IRootProps {
}

export const Root = styled.div`
`;